import axios from 'axios';
import { axiosinstance } from '../../configAxios';

export const getDocumentList = (acDocumentType = '', acTerm = '', anPage = 0, anPageSize = 6) => {
    return (dispatch, state) => {

        const attributes = {};
        attributes['acDocumentType'] = acDocumentType;
        attributes['acTerm'] = acTerm;
        attributes['anPage'] = anPage;
        attributes['anPageSize'] = anPageSize;

        const configRes = axiosinstance(attributes, '8224', 'getDocumentList');

        return axios(configRes)
            .then(response => {
                return response.data.response;
            })
            .catch(function (error) {
                console.error(error);
            });
    }
};
